import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {getFilterGroupValues, s3FilterImagePath} from "../../../misc/utils";

const FeatureInfoBrand = (props) => {

  const {selectionFeatureInfo, filterGroups, feature} = props;

  const currentFeature = feature || selectionFeatureInfo;

  const brandFilterGroup = filterGroups.find(group => group.name === "Brand");
  if (!brandFilterGroup) {
    return null
  }

  const featureBrandValues = getFilterGroupValues(currentFeature, brandFilterGroup);
  if (!featureBrandValues) {
    return null
  }

  const brandFilterValue = brandFilterGroup.values.find(val => val.id === featureBrandValues[0]);
  if (!brandFilterValue || !brandFilterValue.icon) {
    return null
  }

  const styles = {
    backgroundImage: `url(${s3FilterImagePath(brandFilterValue.icon)})`
  };

  return (
    <div className="product-info__brand" style={styles} />
  );
};

FeatureInfoBrand.propTypes = {
  feature: PropTypes.object
}

const mapStateToProps = (store) => {
  return {
    selectionFeatureInfo: store.selectionState.selectionFeatureInfo,
    filterGroups: store.filterState.filterGroups,
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(FeatureInfoBrand);
